import React, {useEffect, useState} from "react";
import styles from "./activityItem/ActivityItem.module.scss";
import SelectBox from "../../../../../Componnets/SelectBox/SelectBox";
import Operations from "./activityItem/Operations";

const ActivityItem = ({ activitiesData, data, addNode, removeNode, editNode, availableEdit, isFirstNode, editActivityName, selectedActivities, availableDelete, themeColor }) => {

  const [selectedActivity, setSelectedActivity] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showAddMetrics, setShowAddMetrics] = useState(false);

  useEffect(() => {
    setSelectedActivity(selectedActivities.activity_name);
  }, [selectedActivities]);

  const handleSelectActivity = (option) => {
    setSelectedActivity(option);
    editActivityName(option);
  }

  const handleEditNode = (type, typeOfFollow) => {
    setIsEditing(!isEditing);
    if (type === "submit" && typeOfFollow) {
      editNode(typeOfFollow);
    }
  }

  const selectBoxStyle = {
    width: 185,
    height: 27,
    border: 0,
    padding: "6px 11px",
    background: "#F0F2FF",
    borderRadius: "5px",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "14px",
    display: "flex",
    alignItems: "center",
    color: "#0A195C",
    zIndex: 2
  }

  return (

    <div className={styles.ActivityItem}>
      <div className={`${styles.item} ${isFirstNode && styles.firstNode} ${isEditing && styles.visible}`}>
        <div>
          <div className={`${styles.icon} d-flex align-items-center justify-content-center`}>
            {
              !selectedActivity
                ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.95043 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95044 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95043C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95043 20.6471Z" stroke="#363853" stroke-width="1.5"/>
                    <circle cx="12" cy="15.5" r="1" fill="#363853"/>
                    <path d="M10 10V9.5C10 8.39543 10.8954 7.5 12 7.5V7.5V7.5C13.1046 7.5 14 8.39543 14 9.5V9.62132C14 10.1839 13.7765 10.7235 13.3787 11.1213L12 12.5" stroke="#363853" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                )
                : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z" stroke="#0A195C" stroke-width="1.5"/>
                    <path d="M9.05485 12C9.05485 12.5523 8.59486 13 8.02742 13C7.45999 13 7 12.5523 7 12C7 11.4477 7.45999 11 8.02742 11C8.59486 11 9.05485 11.4477 9.05485 12Z" fill="#0A195C"/>
                    <path d="M13.0274 12C13.0274 12.5523 12.5674 13 12 13C11.4326 13 10.9726 12.5523 10.9726 12C10.9726 11.4477 11.4326 11 12 11C12.5674 11 13.0274 11.4477 13.0274 12Z" fill="#0A195C"/>
                    <path d="M17 12C17 12.5523 16.54 13 15.9726 13C15.4051 13 14.9452 12.5523 14.9452 12C14.9452 11.4477 15.4051 11 15.9726 11C16.54 11 17 11.4477 17 12Z" fill="#0A195C"/>
                  </svg>
                )

            }
          </div>
          <div className={styles.bgImage}>
            <svg width="262" height="127" viewBox="0 0 262 127" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_1946_3228)">
                <mask id="path-1-outside-1_1946_3228" maskUnits="userSpaceOnUse" x="20" y="20" width="222" height="87" fill="black">
                  <rect fill="white" x="20" y="20" width="222" height="87"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M146.973 39.063C146.488 30.6625 139.522 24 131 24C122.478 24 115.512 30.6625 115.027 39.063L115 39C115 41.3333 113.6 46 108 46H52C36.536 46 24 58.536 24 74V75C24 90.464 36.536 103 52 103H210C225.464 103 238 90.464 238 75V74C238 58.536 225.464 46 210 46H154C148.4 46 147 41.3333 147 39L146.973 39.063Z"/>
                </mask>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M146.973 39.063C146.488 30.6625 139.522 24 131 24C122.478 24 115.512 30.6625 115.027 39.063L115 39C115 41.3333 113.6 46 108 46H52C36.536 46 24 58.536 24 74V75C24 90.464 36.536 103 52 103H210C225.464 103 238 90.464 238 75V74C238 58.536 225.464 46 210 46H154C148.4 46 147 41.3333 147 39L146.973 39.063Z" fill="white"/>
                <path d="M146.973 39.063L142.98 39.2936L150.65 40.6388L146.973 39.063ZM115.027 39.063L111.35 40.6388L119.02 39.2936L115.027 39.063ZM115 39L118.677 37.4242L111 39H115ZM147 39H151L143.323 37.4242L147 39ZM131 28C137.39 28 142.616 32.9969 142.98 39.2936L150.966 38.8323C150.36 28.3282 141.654 20 131 20V28ZM119.02 39.2936C119.384 32.9969 124.61 28 131 28V20C120.346 20 111.64 28.3282 111.034 38.8323L119.02 39.2936ZM111.323 40.5758L111.35 40.6388L118.704 37.4872L118.677 37.4242L111.323 40.5758ZM108 50C112.104 50 115.055 48.2005 116.846 45.7122C118.491 43.4279 119 40.8068 119 39H111C111 39.5266 110.809 40.4055 110.354 41.0378C110.155 41.3136 109.921 41.5257 109.622 41.6795C109.327 41.8317 108.829 42 108 42V50ZM52 50H108V42H52V50ZM28 74C28 60.7452 38.7452 50 52 50V42C34.3269 42 20 56.3269 20 74H28ZM28 75V74H20V75H28ZM52 99C38.7452 99 28 88.2548 28 75H20C20 92.6731 34.3269 107 52 107V99ZM210 99H52V107H210V99ZM234 75C234 88.2548 223.255 99 210 99V107C227.673 107 242 92.6731 242 75H234ZM234 74V75H242V74H234ZM210 50C223.255 50 234 60.7452 234 74H242C242 56.3269 227.673 42 210 42V50ZM154 50H210V42H154V50ZM143 39C143 40.8068 143.509 43.4279 145.154 45.7122C146.945 48.2005 149.896 50 154 50V42C153.171 42 152.673 41.8317 152.378 41.6795C152.079 41.5257 151.845 41.3136 151.646 41.0378C151.191 40.4055 151 39.5266 151 39H143ZM150.65 40.6388L150.677 40.5758L143.323 37.4242L143.296 37.4872L150.65 40.6388Z" fill={themeColor ? themeColor : "#8A0FFF"} mask="url(#path-1-outside-1_1946_3228)"/>
              </g>
              <defs>
                <filter id="filter0_d_1946_3228" x="0" y="0" width="262" height="127" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset/>
                  <feGaussianBlur stdDeviation="10"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1946_3228"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1946_3228" result="shape"/>
                </filter>
              </defs>
            </svg>

          </div>
          <div className={styles.dropdown}>
            <SelectBox
              dropDownValue={selectedActivity ? <span>{ selectedActivity }</span> : 'Find Activity...'}
              style={selectBoxStyle}
              arrow={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.6667 5.66675L8 10.3334L3.33333 5.66675" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              }
            >
              {
                activitiesData && activitiesData.length && activitiesData.map(option => (
                  <div
                    onClick={() => handleSelectActivity(option)}
                    // className={sidebarDataIds.includes(option.id) && styles.disabled}
                  >
                    { option }
                  </div>
                ))
              }
            </SelectBox>
          </div>
          <div className={`${styles.operations} ${isEditing && styles.visible}`}>
            <div>
              <Operations
                addNode={addNode}
                removeNode={removeNode}
                editNode={(type, typeOfFollow) => handleEditNode(type, typeOfFollow)}
                hasConnection={data.type && data.type !== "ENDSEQUENCE"}
                isEditing={isEditing}
                availableDelete={availableDelete}
                availableEdit={availableEdit}
                showAddMetrics={() => setShowAddMetrics(!showAddMetrics)}
              />
            </div>
          </div>
          {
            !isEditing && data.type && <div className={`${styles.followed} ${data.type && (data.type !== "ENDSEQUENCE" && (data.type === "directly_followed" ? styles.directlyFollowed : styles.followedBy))}`}>
              {
                data.type !== "ENDSEQUENCE" && (
                  data.type === "directly_followed" ?
                  <span>Directly Followed</span> :
                  <span>Followed By</span>
                )
              }
             </div>
          }
        </div>
      </div>
      {/*{*/}
      {/*  showAddMetrics &&*/}
      {/*    <div className={styles.addMetrics}>*/}
      {/*      <AddMetrics closeAddMetrics={() => setShowAddMetrics(false)} />*/}
      {/*    </div>*/}
      {/*}*/}

    </div>
  )
}

export default ActivityItem;